import { Injectable } from '@angular/core';
import { ToggleContext, ToggleContextProvider } from '@kw-shared/common';
import { ToggleService } from '../internal/toggle.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseToggleService {
  protected readonly contextProvider: ToggleContextProvider;
  protected readonly commonPrefix = 'kw.common';
  protected readonly flagsPrefix = 'kw.flags';
  protected readonly productTypesPrefix = 'kw.common.productTypes';
  protected readonly connectionTypesPrefix = 'kw.common.connectionTypes';
  protected readonly firmwareVersionsPrefix = 'kw.common.firmwareVersions';

  constructor(protected readonly toggleService: ToggleService) {
    this.contextProvider = ToggleContextProvider.instance;
  }

  public updateContext(context: ToggleContext): void {
    this.contextProvider.updateContext(context);
  }

  public checkConditions(conditionKeys: string | string[]): boolean {
    if (Array.isArray(conditionKeys)) {
      let result = true;
      conditionKeys.forEach(key => {
        result = result && this.toggleService.checkConditions(key);
      });
      return result;
    }

    return this.toggleService.checkConditions(conditionKeys);
  }

  public readFromContext(key: string): any {
    if (this.contextProvider.context.hasOwnProperty(key)) {
      return this.contextProvider.context[key as keyof ToggleContext];
    }
    return undefined;
  }

  public updateConfiguration(config: any): void {
    this.contextProvider.updateConfiguration(config);
  }
}
